import React, { Component } from "react";
import AppActions from "../flux/AppActions";
import Toast from "../toast";
import AjaxLoader from "../components/AjaxLoader";
import CocktailsList from "../components/CocktailsList";

const locale = ( typeof ( window.AppWizardLocale ) !== 'undefined' ? window.AppWizardLocale : false );
if ( !locale ) {
    throw new Error( 'Error: Locale not loaded' );
}

const $ = window.jQuery;
const toast = new Toast();

class PageCocktails extends Component {
    constructor(props) {
        super( props );

        this.inputRef = React.createRef();
        this.state = props.app.state;

        this.__getCocktails = this.__getCocktails.bind( this );
        this.__onCocktailClick = this.__onCocktailClick.bind( this );
    }

    componentDidMount() {
        this.__getCocktails( this.props );
    }

    __goToHomePage(e) {
        e.preventDefault();
        window.history.back();
    }

    __goToBrandsPage(e) {
        e.preventDefault();
        AppActions.updatePage('brands');
    }

    __getCocktails(props) {
        window.scrollTo( {
            top: 0
        } );

        this.setState( {
            loading: true
        } );

        let locale = props.locale;
        let { ajaxurl, nonce_name, nonce_value } = locale;
        let self = this;
        let ajaxConfig = {
            url: ajaxurl,
            method: "POST",
            timeout: 29000,
            cache: false,
            async: true,
            data: {
                action: "bth_ajax",
                request: "get_cocktails",
                //brand_id: props.app.state.brand.id,
                brands: props.app.state.brands.map(brand => brand.id),
                event: props.app.state.event ? props.app.state.event.id : null,
                [nonce_name]: nonce_value
            }
        };

        $.ajax( ajaxConfig )
            .done( function (r) {
                if ( r ) {
                    if ( r.success ) {
                        if ( r.data ) {
                            AppActions.updatePage( 'cocktails' );
                            self.setState( {
                                page_data: r.data.items,
                                ingredients: r.data.ingredients,
                                numar_portii: r.data.numar_portii,
                                loading: false
                            } );
                        }
                        else {
                            toast.show( locale.texts.empty_response, Toast.TYPE_ERROR );
                        }
                    }
                    else {
                        if ( r.data ) {
                            toast.show( r.data, Toast.TYPE_ERROR );
                        }
                        else {
                            toast.show( locale.texts.empty_response, Toast.TYPE_ERROR );
                        }
                    }
                }
                else {
                    toast.show( locale.texts.no_response, Toast.TYPE_ERROR );
                }
            } )
            .fail( function (x, s, e) {
                toast.show( e, Toast.TYPE_ERROR );
            } )
            .always( function () {
                // self.setState( {
                //     loading: false
                // } );
            } );
    }

    __onCocktailClick(cocktailId) {
        let cocktail = this.state.page_data.find(cocktail => cocktail.id === cocktailId);
        if (typeof gtag === 'function') {
            gtag('event', 'cocktail_click', {
                event_label: cocktail.title
            });
        }
        AppActions.updateStore( {
            cocktail: cocktail,
            page: 'shopping_list',
        } );
    }

    render() {
        let page_data = ( this.state.page_data.length ? this.state.page_data : false );
        let ingredients = ( this.state.ingredients ? this.state.ingredients : false );
        let numar_portii = ( this.state.numar_portii ? this.state.numar_portii : false );
        // let brands = [this.state.brand];
        let brands = this.state.brands;
        let cocktailListsByBrand = this.state.loading ? <AjaxLoader/> : brands.map(brand =>
            <section key={brand.id} className="cocktails">
                {/*Headerul asta ar trebui comentat daca nu e nevoie de un header per (grup de cocktailuri) / brand*/}
                <header className="cocktails__header">
                        {brand.brand_label_image ? <img className="cocktails__brand-image" src={brand.brand_label_image} alt=""/> : null}
                        <h3 className="cocktails__heading">
                            Cocktail-uri pe bază de <span className={"brand-name brand-name--"+brand.slug}>{brand.title.toUpperCase()}</span>
                        </h3>
                </header>
                {page_data !== false && page_data.length &&
                <CocktailsList
                    key={brand.id}
                    items={page_data.filter(cocktail => cocktail.brand_ids.indexOf(brand.id) !== -1)} // cocktail.brand_id === brand.id)
                    ingredients={ingredients}
                    numar_portii={numar_portii}
                    onItemClick={this.__onCocktailClick}
                />}
            </section>
        );

        return (
            <React.Fragment>
                <header className="header header--content-page header--cocktails-page p-3 p-xl-5">
                    {/*<div className="header__background-image d-none d-md-block"*/}
                    {/*     // style={{backgroundImage: `url('${locale.img_uri}/afisare-cocktails/savoarea-momentelor-desktop.jpg')`}}*/}
                    {/*>*/}
                    {/*</div>*/}
                    {/*<div className="header__background-image d-block d-md-none"*/}
                    {/*     style={{backgroundImage: `url('${locale.img_uri}/afisare-cocktails/savoarea-momentelor-mobile.png')`}}>*/}
                    {/*</div>*/}

                        <div className="gradient-container">
                            <div className="header__text text-center">
                                <h2 className="header__text__title">{this.state.campaignInfo.wizard_title}</h2>
                                {
                                    this.state.campaignInfo.wizard_header_image ?
                                        <img src={this.state.campaignInfo.wizard_header_image} className='header__image' alt=''/> : null
                                }
                                {/*<h1 className="header__text-title text-center">IDEI DE DRINKS</h1>*/}
                            </div>
                        </div>
                    {/*<picture className="header__image">*/}
                    {/*    <source media="(max-width: 768px)" srcSet={`${locale.img_uri}/afisare-cocktails/sticle-mobile-2.png`}/>*/}
                    {/*    <img src={`${locale.img_uri}/afisare-cocktails/sticle-desktop-2.png`} alt=""/>*/}
                    {/*</picture>*/}
                </header>

                <div className="cocktails-background">
                    <h2 className="title-mobile text-white d-lg-none">{this.state.campaignInfo.wizard_title}</h2>
                    <div className="min-container cocktails-intro">
                        Mixează gustul #dulcespiced al verii. 🤫Spoiler alert: te va face să spui ADOR 🥰 Havana Club #CubanSpiced.<br/>
                        Pentru inspirație de drink-uri, ți-am pregătit o selecție super fresh. Ia-ți rețetele, salvează lista de cumpărături & enjoy! 🌴
                    </div>
                    {/* Aici ar veni textul generic pt toate cocktailurile */}
                    {cocktailListsByBrand}

                    <div className="cocktails__pagination text-center pb-5">
                        {/*<p className="cocktails__pagination-text">*/}
                        {/*    Mergi înapoi la produsele recomandate*/}
                        {/*</p>*/}
                        {/*<a onClick={this.__goToBrandsPage.bind(this)} href="#" className="cocktails__pagination-link">*/}
                        {/*    <img src={locale.img_uri + 'afisare-cocktails/back-button.svg'} alt=""/>*/}
                        {/*</a>*/}
                        <a onClick={this.__goToHomePage.bind(this)} href="#" className="button button--white">
                            ÎNAPOI
                        </a>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default PageCocktails;
